<template>
  <v-layout row justify-center>
    <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="onClickCloseModal()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              class="pa-3"
              style="border-radius: 25px; height: auto;"
              color="secondary"
              @click="onClickSaveSerie()"
            >
              <v-icon class="black--text mr-2">
                mdi-check
              </v-icon>
              <span class="black--text">GUARDAR</span>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-layout align-center justify-center row fill-height>
          <v-flex xs12 md4>
            <v-card flat>
              <v-card-text>
                <v-form ref="serieForm">
                  <v-layout align-center justify-center column fill-height>
                    <v-flex xs12 class="mt-5 mb-5">
                      <h1 class="format-sample">
                        {{ formatSample }}
                      </h1>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout align-center justify-center column fill-height>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex xs12 class="pa-3">
                              <v-select
                                ref="type"
                                :disabled="isUsed"
                                v-model="serieForm.type"
                                :items="types"
                                item-text="text"
                                item-value="value"
                                label="La serie se aplicará en"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-select
                                ref="format"
                                :disabled="isUsed"
                                v-model="serieForm.format"
                                :items="formats"
                                item-text="text"
                                item-value="value"
                                label="Formato"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-text-field
                                ref="init_number"
                                :disabled="isUsed"
                                v-model="serieForm.init_number"
                                :rules="[rules.required]"
                                label="Numeración inicial"
                                required
                                type="number"
                              ></v-text-field>
                            </v-flex>
                            <v-flex
                              v-if="
                                [
                                  'prefijo_serie',
                                  'prefijo_serie_año',
                                  'prefijo_año_serie',
                                ].includes(selectedFormat)
                              "
                              xs12
                              md6
                              class="pa-3"
                            >
                              <v-text-field
                                ref="prefix"
                                :disabled="isUsed"
                                v-model="serieForm.prefix"
                                :rules="[rules.required]"
                                label="Prefijo de la serie"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex
                              v-if="
                                [
                                  'serie_año',
                                  'año_serie',
                                  'prefijo_serie_año',
                                  'prefijo_año_serie',
                                ].includes(selectedFormat)
                              "
                              xs12
                              md6
                              class="pa-3"
                            >
                              <v-select
                                ref="year"
                                :disabled="isUsed"
                                v-model="serieForm.year"
                                :items="years"
                                item-text="text"
                                item-value="value"
                                label="Año de la serie"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-select
                                ref="default_tax"
                                class="pr-2"
                                v-model="serieForm.default_tax"
                                :items="taxes"
                                item-text="text"
                                item-value="value"
                                label="Impuesto por defecto"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-select
                                ref="default_irpf"
                                class="pr-2"
                                v-model="serieForm.default_irpf"
                                :items="irpf"
                                item-text="text"
                                item-value="value"
                                label="IRPF por defecto"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 class="pa-3">
                              <v-select
                                ref="invoice_category"
                                :rules="[]"
                                v-model="serieForm.invoice_category"
                                :items="invoiceCategories"
                                label="Categoría por defecto"
                                :clearable="true"
                                item-value="value"
                                item-text="text"
                                @change="onChangeCategory($event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 class="pa-3">
                              <v-select
                                ref="operation_type"
                                :rules="[]"
                                v-model="serieForm.invoice_operation_type"
                                :items="operationTypes"
                                label="Tipo de operación por defecto"
                                :clearable="true"
                                @change="onChangeOperationType($event)"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 class="pa-3">
                              <v-text-field
                                ref="description"
                                v-model="serieForm.description"
                                label="Descripción"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 class="pa-3">
                              <!-- <v-checkbox
                                v-model="serieForm.reset_annually"
                                label="Reiniciar la numeración de la serie cada año"
                              ></v-checkbox> -->
                              <v-checkbox
                                v-model="serieForm.default"
                                label="Serie predeterminada"
                              ></v-checkbox>
                              <v-checkbox
                                :disabled="isUsed"
                                v-model="serieForm.rectifying"
                                label="Serie rectificativa"
                              ></v-checkbox>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api';
import { irpf, taxes } from '@/modules/openbilling/helpers/taxHelper';

export default {
  name: 'OpenBillingSerieForm',
  components: {},
  props: ['showModal', 'serieId', 'selectedType'],
  data() {
    return {
      tabs: ['Datos'],
      selectedTab: 0,
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
      },
      serieForm: {
        id: null,
        clavedat: null,
        type: null,
        format: 'serie',
        init_number: '1',
        last_number: null,
        prefix: '',
        year: null,
        description: null,
        reset_annually: false,
        rectifying: false,
        default: false,
        used: false,
        default_tax: '21',
        default_irpf: '0',
        invoice_category: null,
        invoice_operation_type: null,
      },
      formatSample: '----',
      types: [
        { text: 'Presupuestos', value: 'presupuesto' },
        { text: 'Facturas', value: 'factura' },
      ],
      formats: [
        { text: 'Serie (sin prefijo)', value: 'serie' },
        { text: 'Serie - Año', value: 'serie_año' },
        { text: 'Año - Serie', value: 'año_serie' },
        { text: 'Prefijo - Serie', value: 'prefijo_serie' },
        { text: 'Prefijo - Serie - Año', value: 'prefijo_serie_año' },
        { text: 'Prefijo - Año - Serie', value: 'prefijo_año_serie' },
      ],
      years: [],
      invoiceCategories: [
        { text: 'Ventas de mercaderías', value: 'Ventas de mercaderías (70000000)' },
        { text: 'Devoluciones de mercaderías', value: 'Devoluciones de mercaderías (70800000)' },
        { text: 'Prestaciones de servicios', value: 'Prestaciones de servicios (70500000)' },
        { text: 'Ingresos por arrendamientos', value: 'Ingresos por arrendamientos (75000000)' },
        { text: 'Ingresos por créditos', value: 'Ingresos por créditos (76200000)' },
      ],
      operationTypes: [
        'Operación interior',
        'Entregas intracomunitarias',
        'Exportaciones',
        'Operaciones no sujetas',
        'Operación exenta de IVA',
      ],
    };
  },
  mounted() {
    this.serieForm.type = this.selectedType;
    this.serieForm.year = new Date().getFullYear();
    this.getYears();
  },
  computed: {
    taxes() {
      return taxes;
    },
    irpf() {
      return irpf;
    },
    show() {
      return this.showModal;
    },
    toolbarTitle() {
      return this.serieId ? 'EDITAR SERIE' : 'NUEVA SERIE';
    },
    billingProfileId() {
      return this.$store.getters.currentOpenbillingProfileId;
    },
    clavedat() {
      return this.$store.state.clavedat;
    },
    selectedFormat() {
      return this.serieForm.format;
    },
    selectedYear() {
      return this.serieForm.year;
    },
    serieInitNumber() {
      return this.serieForm.init_number;
    },
    seriePrefix() {
      return this.serieForm.prefix;
    },
    isUsed() {
      return this.serieForm.used;
    },
  },
  methods: {
    createSerie() {
      Object.keys(this.serieForm).forEach(f => {
        if (this.$refs[f]) {
          this.$refs[f].validate(true);
        }
      });

      this.serieForm.clavedat = this.clavedat;

      apiCtrl
        .post(`/openbilling/${this.clavedat}/series/create`, this.serieForm)
        .then(res => {
          this.$emit('on-saved-serie', res.data.data);
        })
        .catch(err => console.log(err));
    },
    updateSerie() {
      this.serieForm.clavedat = this.clavedat;

      apiCtrl
        .post(`/openbilling/${this.clavedat}/series/update/${this.serieId}`, this.serieForm)
        .then(res => {
          this.$emit('on-saved-serie', res.data.data);
        })
        .catch(err => console.log(err));
    },
    onClickSaveSerie() {
      if (this.serieId) {
        this.updateSerie();
      } else {
        this.createSerie();
      }
    },
    onClickCloseModal() {
      this.$emit('click-on-close');
    },
    getSerieData() {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/series/show/${this.serieId}`)
        .then(res => {
          const data = res.data.data;
          Object.keys(this.serieForm).forEach(key => {
            this.serieForm[key] = data[key];
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getYears() {
      const currentDate = new Date();
      let startYear = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1;

      // If it is november or december we add the next year in the range
      if (month >= 11) {
        startYear = startYear + 1;
      }
      let years = [];
      for (let i = 10; i >= 0; i--) {
        years.push({ text: startYear - i, value: startYear - i });
      }
      this.years = years.sort((a, b) => b.value - a.value);
    },
    refactorSampleFormat() {
      switch (this.selectedFormat) {
        case 'serie':
          this.formatSample = this.serieInitNumber.padStart(3, '0');
          break;
        case 'serie_año':
          this.formatSample = `${this.serieInitNumber.padStart(3, '0')}${this.selectedYear}`;
          break;
        case 'año_serie':
          this.formatSample = `${this.selectedYear}${this.serieInitNumber.padStart(3, '0')}`;
          break;
        case 'prefijo_serie':
          this.formatSample = `${this.seriePrefix}${this.serieInitNumber.padStart(3, '0')}`;
          break;
        case 'prefijo_serie_año':
          this.formatSample = `${this.seriePrefix}${this.serieInitNumber.padStart(3, '0')}${
            this.selectedYear
          }`;
          break;
        case 'prefijo_año_serie':
          this.formatSample = `${this.seriePrefix}${
            this.selectedYear
          }${this.serieInitNumber.padStart(3, '0')}`;
          break;
        default:
          this.formatSample = this.serieInitNumber.padStart(3, '0');
      }
    },
    onChangeCategory(value) {
      if (!value) {
        this.serieForm.invoice_category = null;
      }
    },
    onChangeOperationType(value) {
      if (!value) {
        this.serieForm.invoice_operation_type = null;
      }
    },
  },
  watch: {
    serieId: function() {
      if (this.serieId) {
        this.getSerieData();
      }
    },
    selectedFormat: function() {
      this.refactorSampleFormat();
    },
    selectedYear: function() {
      this.refactorSampleFormat();
    },
    serieInitNumber: function() {
      this.refactorSampleFormat();
    },
    seriePrefix: function() {
      this.refactorSampleFormat();
    },
  },
};
</script>

<style scoped>
.format-sample {
  padding: 1rem 3rem;
  border: 5px dotted #00afa8;
}
</style>
